import { OnboardingTour, StoredOnboardingProgress } from "./types";

const STORAGE_PREFIX = "zivtrack:onboarding";

const buildStorageKey = (coachId: string, tourId: string, version: number) => `${STORAGE_PREFIX}:${coachId}:${tourId}:v${version}`;

export const readOnboardingProgress = (coachId: string, tour: OnboardingTour): StoredOnboardingProgress | null => {
    try {
        const raw = window.localStorage.getItem(buildStorageKey(coachId, tour.id, tour.version));
        if (!raw) return null;
        const parsed = JSON.parse(raw) as StoredOnboardingProgress;
        if (parsed.version !== tour.version) return null;
        return {
            ...parsed,
            completedStepIds: Array.isArray(parsed.completedStepIds)
                ? Array.from(new Set(parsed.completedStepIds.filter(stepId => typeof stepId === "string")))
                : [],
        };
    } catch (error) {
        console.warn("readOnboardingProgress() failed", error);
        return null;
    }
};

export const writeOnboardingProgress = (coachId: string, tour: OnboardingTour, progress: StoredOnboardingProgress) => {
    try {
        window.localStorage.setItem(buildStorageKey(coachId, tour.id, tour.version), JSON.stringify(progress));
        //  console.log("writeOnboardingProgress --->", progress);
    } catch (error) {
        console.warn("writeOnboardingProgress() failed", error);
    }
};

export const clearOnboardingProgress = (coachId: string, tourId: string) => {
    try {
        const prefix = `${STORAGE_PREFIX}:${coachId}:${tourId}:`;
        for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
            const key = window.localStorage.key(index);
            if (key?.startsWith(prefix)) {
                window.localStorage.removeItem(key);
            }
        }
    } catch (error) {
        console.warn("clearOnboardingProgress() failed", error);
    }
};
